import { useNavigate } from '@tanstack/react-router'
import { Boxes } from 'lucide-react'
import { Page } from '../../components/layout/AppShell'
import { PageHeader } from '../../components/layout/PageHeader'
import { Badge, Card, Grid, IconBadge } from '../../components/ui'

interface Model {
  slug: string
  name: string
  description: string
  status: 'skeleton' | 'live'
}

const REGISTERED_MODELS: Model[] = [
  {
    slug: 'merit-order',
    name: 'Merit order',
    description:
      'Fundamental fair-value model for the Polish power market. Computes the clearing price each delivery hour from fuel costs, plant availability, and demand.',
    status: 'skeleton',
  },
]

export function ModelsPage() {
  const navigate = useNavigate()
  return (
    <Page header={<PageHeader crumbs={[{ label: 'Models' }]} />}>
      <Grid cols={3}>
        {REGISTERED_MODELS.map((m) => (
          <Card key={m.slug} onClick={() => navigate({ to: `/models/${m.slug}` })}>
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2">
                <IconBadge color="gray">
                  <Boxes size={16} />
                </IconBadge>
                <span className="font-medium text-gray-900">{m.name}</span>
              </div>
              <Badge tone={m.status === 'live' ? 'green' : 'neutral'}>{m.status}</Badge>
            </div>
            <p className="mt-2 text-sm text-gray-600">{m.description}</p>
          </Card>
        ))}
      </Grid>
    </Page>
  )
}
